module.exports = __webpack_public_path__ + "static/media/nft-detail.3a87828a.jpg";